import { endpoints } from '../config/endpoints';
import { apiFetch } from './client';
import type { Session } from '../types/session.types';

export async function fetchSessions(
  workspaceId: string,
  params: { limit?: number; offset?: number } = {},
): Promise<Session[]> {
  const limit = params.limit ?? 50;
  const offset = params.offset ?? 0;

  const response = await apiFetch(
    `${endpoints.sessions.list()}?workspaceId=${encodeURIComponent(workspaceId)}&limit=${limit}&offset=${offset}`,
  );

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const result = await response.json();
  // Backend returns { data: Session[], pagination: {...} }
  return (result.data || result.sessions || []) as Session[];
}

export async function deleteSession(sessionId: string): Promise<void> {
  const response = await apiFetch(endpoints.sessions.delete(sessionId), {
    method: 'DELETE',
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }
}
